import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllProductsTable from './Table';
import { DLModal } from 'appSrc/components/Shards';
import style from './styles/style.module.css';

class ProductSearchModal extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            products: [],
            searchValue: '',
        };
        this.productQueryObject = {
            page: 1,
            limit: 25,
            sort: 'title,desireid',
            search: undefined,
        };

        this.loadProducts();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.productQueryObject.page = 1;
            this.productQueryObject.search = this.state.searchValue || undefined;

            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.products = [];
                return prevState;
            } );
            this.loadProducts();
        }
    }
    loadProducts = () => {
        return this.props.getProducts( this.productQueryObject )
        .then( ( products ) => {
            this.productQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.products = prevState.products.concat( products );
                return prevState;
            } );
            return products;
        } );
    }

    render() {
        const { fetching, products, searchValue } = this.state;

        return (
            <DLModal title='Product Search'
            className={ style.productSearchModal }
            closeHandler={ this.props.closeModal }>
                <div>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                    </div>
                    <div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllProductsTable
                            products={ products }
                            markedProducts={ this.props.markedProducts }
                            loadMore={ this.loadProducts }
                            onSubmit={ this.props.onSubmit }
                            elementHeight={ 90 } />
                        }
                    </div>
                </div>
            </DLModal>
        );
    }
}
ProductSearchModal.defaultProps = {
    onSubmit: () => {},
};

const mapDispatchToProps = () => {
    return {
        getProducts: ( queryObject ) => {
            return dAPI.get( '/admin/desires', queryObject );

        },
    };
};

export default connect( null, mapDispatchToProps )( ProductSearchModal );
